import { merge } from 'lodash'
import { product, TYPES as PRODUCT_TYPES } from './product/store'
import { productcategory, TYPES as PRODUCT_CATEGORY_TYPES } from './product-category/store'
import { unittype, TYPES as UNIT_TYPE_TYPES } from './unit-type/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      product: {
        namespaced: true,
        modules: {
          product,
          productcategory,
          unittype
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    UNIT_TYPE_TYPES,
    PRODUCT_CATEGORY_TYPES,
    PRODUCT_TYPES
  )

export { store, TYPES }
